import { useInfiniteQuery } from '@tanstack/react-query';

import { useFetch } from '@/modules/common';
import { PaginatedResponse } from '@/modules/common/types';

import { SystemPromptResponse } from '../types';

const PAGE_SIZE = 20;

export function usePromptsByCategoryInfinite(categoryId: string) {
  const fetchClient = useFetch();

  const query = useInfiniteQuery<PaginatedResponse<SystemPromptResponse>>({
    queryKey: ['prompts-by-category-infinite', categoryId],
    queryFn: ({ pageParam }) =>
      fetchClient(
        `/system-prompts/categories/${categoryId}/prompts?page=${pageParam}&pageSize=${PAGE_SIZE}`,
        { method: 'GET' }
      ),
    getNextPageParam: (lastPage) => {
      const { page, total } = lastPage.pagination;
      return page * PAGE_SIZE < total ? page + 1 : undefined;
    },
    initialPageParam: 1,
    enabled: !!categoryId,
  });

  return {
    data: query.data?.pages.flatMap((page) => page.items) ?? [],
    hasNextPage: query.hasNextPage,
    isFetchingNextPage: query.isFetchingNextPage,
    fetchNextPage: query.fetchNextPage,
    isLoading: query.isLoading,
  };
}
